import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useUIStore } from '@/stores/ui.store';

const { Content, Footer } = Layout;

export function AppLayout() {
  const sidebarCollapsed = useUIStore((s) => s.sidebarCollapsed);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar />
      <Layout style={{ marginLeft: sidebarCollapsed ? 80 : 240 }}>
        <Header />
        <Content style={{ margin: 24, padding: 24, background: 'transparent' }}>
          <Outlet />
        </Content>
        <Footer style={{ textAlign: 'center', padding: '12px 24px' }}>
          Tribe Admin Panel &copy; {new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
}
